import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlotlyService } from '../plotly-graph/plotly.service';

@Component({
  selector: 'app-performance-graph-modal',
  templateUrl: './performance-graph-modal.component.html',
  styleUrls: ['./performance-graph-modal.component.less']
})
export class PerformanceGraphModalComponent implements OnInit {
  @Input() data: any;
  @Input() modalType: any;

  countGraphTypes = ['Pie', 'Bar'];
  responseTimeGraphTypes = ['Bar', 'Line'];
  selectedGraphType: any = 'Pie';
  dataType = ['Count', 'Response Time'];
  selectedDataType: any = 'Count';


  constructor(public modal: NgbActiveModal,private plotyService: PlotlyService) { }

  ngOnInit(): void {
    if(this.modalType == 'TESTCASE') {
      this.showTestCaseGraph(this.data);
      console.log(this.data)
    }
  }

  showTestCaseGraph(data: any) {
    let trace = [{
      values: [this.data.passedCount, this.data.failedCount, this.data.skippedCount, this.data.relayErrorCount, this.data.validSkipCount],
      labels: ['Pass', 'Fail', 'Skipped', 'Relay Error', 'Valid Skip'],
      type: 'pie'
    }]
    this.plotyService.generateSimplePerformancePie('Performance Graph', 'pie-graph', trace)
  }

  updateGraph() {
    if(this.selectedDataType === 'Count') {
      if(this.selectedGraphType === 'Pie') {
        let trace = [{
          values: [this.data.passedCount, this.data.failedCount, this.data.skippedCount, this.data.relayErrorCount, this.data.validSkipCount],
          labels: ['Pass', 'Fail', 'Skipped', 'Relay Error', 'Valid Skip'],
          type: 'pie'
        }]
        this.plotyService.generateSimplePerformancePie('Performance Graph', 'pie-graph', trace)
      } else if(this.selectedGraphType === 'Bar') {
        let trace = [{
          y: [this.data.passedCount, this.data.failedCount, this.data.skippedCount, this.data.relayErrorCount, this.data.validSkipCount],
          x: ['Pass', 'Fail', 'Skipped', 'Relay Error', 'Valid Skip'],
          type: 'bar'
        }]
        this.plotyService.generateSimplePerformanceBar('Performance Graph', 'pie-graph', trace)
      }
    } else if(this.selectedDataType === 'Response Time') {
      if(this.selectedGraphType === 'Bar') {
        let endpointArray = this.data.endPoints.sort((a, b) => a.sequence - b.sequence);
        let x = [];
        let y = [];
        let text = [];
        for(let i=0; i< endpointArray.length; i++) {
          x.push(endpointArray[i].name + "-" + endpointArray[i].sequence)
          text.push(endpointArray[i].name)
          y.push(endpointArray[i].endPointExecution.apiResponseTime)
        }
        this.plotyService.generateSimplePerformanceBarGraph('Response Time', 'pie-graph', x,y, 'Endpoint', 'Time(Sec)', text)
      } else if(this.selectedGraphType === 'Line') {
        let endpointArray = this.data.endPoints.sort((a, b) => a.sequence - b.sequence);
        let x = [];
        let y = [];
        let text = [];
        for(let i=0; i< endpointArray.length; i++) {
          x.push(endpointArray[i].name + "-" + endpointArray[i].sequence)
          text.push(endpointArray[i].name)
          y.push(endpointArray[i].endPointExecution.apiResponseTime)
        }
        this.plotyService.generateSimpleLineGraph('Response Time', 'pie-graph', x, y, 'Endpoint', 'Time(Sec)', text)
      }
    }
  }

}
